export default {
  init($element) {

  },
  finalize($element) {
    $element.find('.cta').each(function() {
      const $cta = $(this);
      const ctaX = $cta.offset().left;
      const ctaY = $cta.offset().top;

      $(this).find('.cta-link').on('mouseenter', function() {
        $cta.addClass('hover');
      });
      
      $(this).find('.cta-link').on('mouseleave blur', function() {
        $cta.removeClass('hover');
      });

      $(this).find('.cta-link').on('mousemove', function(e) {
        const posX = e.pageX - ctaX;
        const posY = e.pageY - ctaY;

        $cta.find('.cta-inner .cta-browser').css({ 'left': `${posX}px`, 'top': `${posY}px` });
        $cta.find('.cta-border .cta-border-discover').css({ 'left': `${posX}px`, 'top': `${posY}px` });
      });
    });
  },
}


// WEBPACK FOOTER //
// ./scripts/partials/home/fourColumnCtas.js